import * as view from './view';
import * as editor from './editor';

export default { view, editor };
